"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatar_list = void 0;
const design_config_1 = require("@unboared/design.config");
exports.avatar_list = [
    (0, design_config_1.getAvatarPath)("adventurer/pppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ppppppppppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/pppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/pppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/polk.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/pppppppppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/z.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/zeeeerr.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/sss.svg"),
    (0, design_config_1.getAvatarPath)("adventurer/ss.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/pppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ppppppppppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/pppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/pppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/polk.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/pppppppppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/z.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/zeeeerr.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/sss.svg"),
    (0, design_config_1.getAvatarPath)("big-smile/ss.svg"),
    (0, design_config_1.getAvatarPath)("bottts/pppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ppppppppppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/pppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/pppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/polk.svg"),
    (0, design_config_1.getAvatarPath)("bottts/pppppppppppppppppppppppppppppppp.svg"),
    (0, design_config_1.getAvatarPath)("bottts/z.svg"),
    (0, design_config_1.getAvatarPath)("bottts/zeeeerr.svg"),
    (0, design_config_1.getAvatarPath)("bottts/sss.svg"),
    (0, design_config_1.getAvatarPath)("bottts/ss.svg")
];
//# sourceMappingURL=avatar_list.js.map